"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triagePages = exports.triagePageByPath = exports.pageByPathV2 = exports.pageByPath = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Queries for a page by it's path
 *
 * @param {string} parent - The parent slug of the page
 * @param {string} subLevel - The subLevel slug of the page
 * @param {string} slug - The slug of the page
 * @returns {object} Contentful query
 */
var pageByPath = function pageByPath(_ref) {
  var _ref$parent = _ref.parent,
    parent = _ref$parent === void 0 ? null : _ref$parent,
    _ref$subLevel = _ref.subLevel,
    subLevel = _ref$subLevel === void 0 ? null : _ref$subLevel,
    slug = _ref.slug,
    pageTypes = _ref.pageTypes;
  return _objectSpread(_objectSpread(_objectSpread({
    content_type: 'page',
    'fields.slug': slug
  }, parent ? {
    'fields.parent.sys.contentType.sys.id': 'page',
    'fields.parent.fields.slug': parent
  } : {
    'fields.parent[exists]': false
  }), subLevel ? {
    'fields.subLevel.sys.contentType.sys.id': 'page',
    'fields.subLevel.fields.slug': subLevel
  } : {
    'fields.subLevel[exists]': false
  }), pageTypes ? {
    'fields.pageType[in]': pageTypes.join(',')
  } : {});
};

/**
 * Queries for a page by it's path (v2)
 *
 * @param {string} parent - The parent slug of the page
 * @param {string} subLevel - The subLevel slug of the page
 * @param {string} slug - The slug of the page
 * @returns {object} Contentful query
 */
exports.pageByPath = pageByPath;
var pageByPathV2 = function pageByPathV2(_ref2) {
  var _ref2$parent = _ref2.parent,
    parent = _ref2$parent === void 0 ? null : _ref2$parent,
    _ref2$subLevel = _ref2.subLevel,
    subLevel = _ref2$subLevel === void 0 ? null : _ref2$subLevel,
    slug = _ref2.slug,
    pageTypes = _ref2.pageTypes;
  return _objectSpread(_objectSpread(_objectSpread({
    content_type: 'page_v2',
    'fields.slug': slug
  }, parent ? {
    'fields.parent.sys.contentType.sys.id': 'page_v2',
    'fields.parent.fields.slug': parent
  } : {
    'fields.parent[exists]': false
  }), subLevel ? {
    'fields.subLevel.sys.contentType.sys.id': 'page_v2',
    'fields.subLevel.fields.slug': subLevel
  } : {
    'fields.subLevel[exists]': false
  }), pageTypes ? {
    'fields.pageType[in]': pageTypes.join(',')
  } : {});
};

/**
 * Queries for a triage page
 *
 * @param {string} slug - The slug of the page
 * @returns {object} Contentful query
 */
exports.pageByPathV2 = pageByPathV2;
var triagePageByPath = function triagePageByPath(_ref3) {
  var slug = _ref3.slug;
  return {
    content_type: 'triagePage',
    'fields.slug': slug
  };
};

/**
 * Queries for all triage pages
 *
 * @returns {object} Contentful query
 */
exports.triagePageByPath = triagePageByPath;
var triagePages = function triagePages() {
  return {
    content_type: 'triagePage'
  };
};
exports.triagePages = triagePages;